import { takeLatest, call, put } from "redux-saga/effects";
import {
  SUBMIT_COMPETITOR_PROFILE_V3_REQUEST,
  submitCompetitorProfileV3Success,
  submitCompetitorProfileV3Failure,
} from "../actions/competitorProfileV3Actions";
import { fetchCompetitorProfileV3 } from "../../../services/accIqService";

// Worker Saga
function* handleCompetitorProfileV3Submission(action) {
  try {
    const response = yield call(
      fetchCompetitorProfileV3,
      action.payload.dimension,
      action.payload.client,
      action.payload.company
    );
    yield put(submitCompetitorProfileV3Success(response));
  } catch (error) {
    yield put(
      submitCompetitorProfileV3Failure(error?.message || "Something went wrong")
    );
  }
}

// Watcher Saga
export function* watchCompetitorProfileV3Submission() {
  yield takeLatest(
    SUBMIT_COMPETITOR_PROFILE_V3_REQUEST,
    handleCompetitorProfileV3Submission
  );
}
